import { Button } from '@mui/material'
import Icon from '@mui/material/Icon'
import makeStyles from '@mui/styles/makeStyles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CalendarSearchToolbar from 'components/navbar/CalendarSearchToolbar'
import format from 'date-fns/format'
import { SORT_CLICKS } from 'lib/constants'
import { useRouter } from 'next/router'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  label: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  button: {
    height: '36px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '36px',
      paddingLeft: '6px',
      paddingRight: '6px'
    }
  },
  icon: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0
    }
  }
}))

function ButtonField (props) {
  const classes = useStyles()

  const {
    setOpen,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {}
  } = props

  return (
    <Button
      variant='contained'
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      startIcon={<Icon>event</Icon>}
      classes={{ startIcon: classes.icon }}
      onClick={() => setOpen?.((prev) => !prev)}
      className={classes.button}

    >
      <span className={classes.label}>Kalender</span>
    </Button>
  )
}

function ButtonDatePicker (props) {
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <DatePicker
      slots={{ ...props.slots, field: ButtonField, toolbar: CalendarSearchToolbar }}
      slotProps={{
        ...props.slotProps,
        field: { setOpen },
        toolbar: { onClick: handleClose },
        layout: { sx: { display: 'flex', flexDirection: 'column' } }
      }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  )
}

export default function CalendarSearch ({ handler }) {
  const [value, setValue] = React.useState(null)
  const router = useRouter()

  const onDateChange = val => {
    handler()
    const formattedDate = format(val, 'dd.MM.yyyy')
    router.push({
      pathname: '/search',
      query: `date=${formattedDate}&sort=${SORT_CLICKS}`
    }).then(() => window.scrollTo(0, 0))
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ButtonDatePicker
        value={value}
        disableFuture
        onChange={onDateChange}
        closeOnSelect
      />
    </LocalizationProvider>
  )
}
